import React, { useState } from 'react';
import ModuleButton from './ModuleButton';
import { API } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';

import './ModulesDashboard.scss';
import { Login } from '@mui/icons-material';

function ModulesDashboard({ modules, pageTitle, worldMapImage, world1, grade, unit }) {
  const [day, setDay] = useState(0);
  const [id, setID] = useState('');

  const navigate = useNavigate();

  const checkbouncing = (bouncing, moduleDayCompleted, idx, previousModuleDayCompleted) =>{
    if (unit === 1){
      switch (grade) {
        case 'Preschool':
          return bouncing
        case 'Kindergarten':
          return bouncing
        case '1st Grade':
          return moduleDayCompleted >= 5 ? false : previousModuleDayCompleted >= 5 ? true : idx === 0 ? true : false
        case '2nd Grade':
          return bouncing
        case '3rd Grade':
          return bouncing
        case 'Teacher Account':
          return false
        case 'Free Play':
          return false
        default:
          return bouncing
      }
    }
    else if (unit === 2){
      switch (grade) {
        case 'Preschool':
          return bouncing
        case 'Kindergarten':
          return bouncing
        case '1st Grade':
          return bouncing
        case '2nd Grade':
          return moduleDayCompleted >= 4 ? false : previousModuleDayCompleted >= 4 ? true : idx === 0 ? true : false
        case '3rd Grade':
          return bouncing
        case 'Teacher Account':
          return false
        case 'Free Play':
          return false
        default:
          return bouncing
      }
    }
    else if (unit === 3){
      switch (grade) {
        case 'Preschool':
          return idx === 3 ? false : bouncing
        case 'Kindergarten':
          return idx === 3 ? false : bouncing
        case '1st Grade':
          return bouncing
        case '2nd Grade':
          return bouncing
        case '3rd Grade':
          return bouncing
        case 'Teacher Account':
          return false
        case 'Free Play':
          return false
        default:
          return bouncing
      }
    }
    else if (unit === 4){
      switch (grade) {
        case 'Preschool':
          return bouncing
        case 'Kindergarten':
          return bouncing
        case '1st Grade':
          return bouncing
        case '2nd Grade':
          return bouncing
        case '3rd Grade':
          return bouncing
        case 'Teacher Account':
          return false
        case 'Free Play':
          return false
        default:
          return bouncing
      }
    }

  }

  const checkGrade = (previousModuleCompleted, previousModuleDayCompleted, idx) =>{
    if (unit === 1){
      switch (grade) {
        case 'Preschool':
          return previousModuleCompleted
        case 'Kindergarten':
          return previousModuleCompleted
        case '1st Grade':
          return idx === 0 ? true : previousModuleDayCompleted >= 5 ? true : false 
        case '2nd Grade':
          return previousModuleCompleted
        case '3rd Grade':
          return previousModuleCompleted
        case 'Teacher Account':
          return true
        case 'Free Play':
          return true
        default:
          return previousModuleCompleted
      }
    }
    else if (unit === 2){
      switch (grade) {
        case 'Preschool':
          return previousModuleCompleted
        case 'Kindergarten':
          return previousModuleCompleted
        case '1st Grade':
          return previousModuleCompleted
        case '2nd Grade':
          return idx === 0 ? true : previousModuleDayCompleted >= 4 ? true : false 
        case '3rd Grade':
          return previousModuleCompleted
        case 'Teacher Account':
          return true
        case 'Free Play':
          return true
        default:
          return previousModuleCompleted
      }
    }
    else if (unit === 3){
      switch (grade) {
        case 'Preschool':
          return previousModuleCompleted
          // return idx === 3 ? false : previousModuleCompleted
        case 'Kindergarten':
          return previousModuleCompleted
          // return idx === 3 ? false : previousModuleCompleted
        case '1st Grade':
          return previousModuleCompleted
        case '2nd Grade':
          return previousModuleCompleted
        case '3rd Grade':
          return previousModuleCompleted
        case 'Teacher Account':
          return true
        case 'Free Play':
          return true
        default:
          return previousModuleCompleted
      }
    }
    else if (unit === 4){
      switch (grade) {
        case 'Preschool':
          return previousModuleCompleted
        case 'Kindergarten':
          return previousModuleCompleted
        case '1st Grade':
          return previousModuleCompleted
        case '2nd Grade':
          return previousModuleCompleted
        case '3rd Grade':
          return previousModuleCompleted
        case 'Teacher Account':
          return true
        case 'Free Play':
          return true
        default:
          return previousModuleCompleted
      }
    }

  }


  //use this
  const resetDB = async () => {
    const moduleId = id || modules[0].moduleID;
    const myInit = {
      body: {
        id: moduleId,
        day_completed: day === '8' ? world1 ? day :'9' : day,
        step_completed: 'notstarted',
        game_details: null,
      },
    };

    try {
      await API.put('TIR', '/v3/student/module', myInit);
      navigate('/');
    } catch (error) {
      console.log(error.response);
    }
  };

  const handleChange = (e) => {
    setID(e.target.value);
  };

  const handleChangeNum = ({ target }) => setDay(target.value);

  const handleDone = (event) => {
    // 👇️ prevent page refresh
    event.preventDefault();
    resetDB();
  };

  return (
    <div className='unit-container'>
      <header>
        <button onClick={() => navigate('/unitPage')}>&#60; Units</button>
      </header>

      <main className='unit-content'>
        <div className='unit-world-title'>{pageTitle}</div>
        <div
          className='unit-world-map'
          style={{ backgroundImage: `url(${worldMapImage})` }}
        >
          {modules.map((module, idx) => (
            <ModuleButton
              key={`${module.moduleID}_${idx}`}
              bouncing={checkbouncing(module.bouncing, module.daysCompleted, idx, module.previousModuleDayCompleted)}
              className={module.className}
              daysCompleted={module.daysCompleted}
              totalDays={module.totalDays}
              moduleBackground={module.background}
              moduleDestiny={module.destiny}
              moduleImage={module.image}
              moduleTitle={module.title}
              moduleWelcomeVideo={module.welcomeVideo}
              notStarted={module.notStarted}
              complete={module.complete}
              inProgress={module.inProgress}
              previousModuleCompleted={checkGrade(module.previousModuleCompleted, module.previousModuleDayCompleted, idx)}
              module={module}
              teacher={(grade === "Teacher Account" || grade === "Free Play")?true:false}
            />
          ))}
        </div>
      </main>

      {(!window.location.href.includes('wearefriends.cool') ? true : window.location.href.includes('staging') ? true : false )  && <form className='database-form' onSubmit={handleDone}>
        <h5>
          Module Name:
          <select value={id} onChange={handleChange}>
            {modules.map((module) => {
              return (
                <option key={module.moduleID} value={module.moduleID}>
                  {module.title}
                </option>
              );
            })}
          </select>
        </h5>
        <h5>
          Day Completed:
          <input type='number' value={day} onChange={handleChangeNum} />
        </h5>
        <h5>
          <input type='submit' value='Submit' />
        </h5>
      </form>}
    </div>
  );
}

export default ModulesDashboard;
